import React from 'react'
import { FiArrowRight } from 'react-icons/fi'

export const Follow = ({projectId}) => {
    return (
        <React.Fragment>
            <div className={`btn btn-primary active`} >
                <p> Follow </p> 
                <FiArrowRight />
            </div>
        </React.Fragment>
    )
}